import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import moment from 'moment';

import Button from '../components/Button';
import FilterDialog from '../components/FilterDialog';
import PageGrid from '../components/PageGrid';
import PageHeader from '../components/PageHeader';
import { PersonContext } from '../contexts/PersonContext';
import history from '../history';

const AttachmentsExport = () => {
  const location = useLocation();
  const { match } = useParams();
  const { organizationId, organizationName } = useContext(PersonContext);

  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
    startDateSelect: null,
    endDateSelect: null,
    entityId: null,
    propertyId: null,
    unitId: null,
    entityIdSelect: null,
    propertyIdSelect: null,
    unitIdSelect: null,
  });

  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(true);
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const exportZip = async (filterData) => {
    setIsExportDialogOpen(true);
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${import.meta.env.VITE_FEATHERS_SOCKET}/export-zip`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('feathers-jwt')}`,
        },
        body: JSON.stringify({
          organizationId,
          page: location.pathname,
          filter: filterData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData);
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${organizationName} ${moment(filterData.startDate).format('ll')}-${moment(filterData.endDate).format('ll')} REI Hub Attachments Export.zip`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateFilter = (newFilter) => {
    setFilter(newFilter);
    setIsFilterDialogOpen(false);
    exportZip(newFilter);
  };

  useEffect(() => {
    if (!isFilterDialogOpen && !isExportDialogOpen) {
      history.replace('/reports');
    }
  }, [isFilterDialogOpen, isExportDialogOpen]);

  return (
    <PageGrid>
      <PageHeader match={match} title="Attachments Export" />
      {isFilterDialogOpen && (
        <FilterDialog
          filter={filter}
          isOpen
          closeDialog={() => {
            setIsFilterDialogOpen(false);
          }}
          updateFilter={(filter) => updateFilter(filter)}
          dateRange
          scope={['Full Portfolio', 'Sub-Portfolio', 'Property', 'Unit']}
          required={['dateRange', 'scope']}
        />
      )}
      <Dialog
        open={isExportDialogOpen}
        scroll="body"
        maxWidth="sm"
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="exportAttachmentDialog"
      >
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            Exporting Attachments
          </Typography>
          {!error && (
            <Typography gutterBottom>
              Please allow up to 60 seconds for the export to complete. Your file will download automatically when
              finished.
            </Typography>
          )}
          {error && <Typography color="error">{error && `Error: ${error.message}`}</Typography>}
          <DialogActions>
            {!error && (
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={() => {
                  setIsExportDialogOpen(false);
                }}
                disabled={isLoading}
              >
                Done
              </Button>
            )}
            {error && (
              <Button
                color="primary"
                onClick={() => {
                  setIsExportDialogOpen(false);
                  setIsFilterDialogOpen(true);
                }}
              >
                Back
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    </PageGrid>
  );
};

export default AttachmentsExport;
